import numeralFormatter, { NumeralFormats } from './numeralFormatter';

const roundedCurrencyCellFormatter = ({ value }) =>
  numeralFormatter({ value, format: NumeralFormats.NUMBER_WITHOUT_DECIMALS });

export default roundedCurrencyCellFormatter;
